import React, { FunctionComponent } from 'react';

const HeroCarouselScrollSymbol: FunctionComponent<{}> = () => {
  return (
    <div className="hero-carousel__scroll-symbol">
      <div className="hero-carousel__mouse-scroll">
        <span className="hero-carousel__mouse">
          <span className="hero-carousel__mouse-movement"></span>
        </span>
      </div>
    </div>
  );
};

export default HeroCarouselScrollSymbol;
